import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "expand-45, enlarge" }, [
      _createElementVNode("path", {
        id: "vector",
        d: "M9.00065 2.33203H13.6673V6.9987M9.00065 6.9987L13.1361 2.86328M7.00065 8.9987L2.86523 13.1341M2.33398 8.9987V13.6654H7.00065",
        stroke: "currentColor",
        "stroke-linecap": "square"
      })
    ], -1)
  ])))
}
export default { render: render }